// extracted by mini-css-extract-plugin
export default {"container":"ScreenSimulation_container__KQsKz","line":"ScreenSimulation_line__0+8u3"};